module.exports = __webpack_public_path__ + "media/notification.fb4c7038.wav";